export const STARTED_LOADING_HIGHLIGHT_ITEMS_FOR_GUIDE =
    'STARTED_LOADING_HIGHLIGHT_ITEMS_FOR_GUIDE';
export const FAILED_LOADING_HIGHLIGHT_ITEMS_FOR_GUIDE =
    'FAILED_LOADING_HIGHLIGHT_ITEMS_FOR_GUIDE';
export const SUCCESS_LOADING_HIGHLIGHT_ITEMS_FOR_GUIDE =
    'SUCCESS_LOADING_HIGHLIGHT_ITEMS_FOR_GUIDE';
export const STARTED_SAVING_HIGHLIGHT_ITEMS = 'STARTED_SAVING_HIGHLIGHT_ITEMS';
export const FAILED_SAVING_HIGHLIGHT_ITEMS = 'FAILED_SAVING_HIGHLIGHT_ITEMS';
export const SUCCESS_SAVING_HIGHLIGHT_ITEMS = 'SUCCESS_SAVING_HIGHLIGHT_ITEMS';
